import { ImplementationKind } from '@finch-api/common/dist/internal/connect/authorize';
import { PayrollProviderId } from './types';

export enum ScopeCategory {
  BASE = 'base',
  ORGANIZATION_ONLY = 'organization_only',
  PAY_AND_ORGANIZATION = 'pay_and_organization',
  BENEFITS = 'benefits',
  BENADMIN = 'benadmin',
}

export interface InstructionConfig {
  url: string;
  innerHtmlToScroll?: Record<string, string>;
}

export type ScopedAuthInstructions = Partial<
  Record<
    PayrollProviderId,
    Partial<
      Record<
        ImplementationKind,
        Partial<Record<ScopeCategory, InstructionConfig>> & {
          innerHtmlToScroll?: Record<string, string>;
        }
      >
    >
  >
>;

export const SCOPED_AUTH_INSTRUCTIONS: ScopedAuthInstructions = {
  [PayrollProviderId.ULTI_PRO]: {
    [ImplementationKind.API_TOKEN]: {
      // Implementation-level innerHtmlToScroll (common across all scopes)
      innerHtmlToScroll: {
        'step-1':
          'Step 1: Create a Service Account with the Necessary Permissions',
        'step-2': 'Step 2: Retrieve API Keys & Web Service URL',
      },
      // Base configuration (fallback)
      [ScopeCategory.BASE]: {
        url: 'https://support.tryfinch.com/hc/en-us/articles/26209058806548-UKG-Pro-Add-a-Service-User',
      },
      // Organization-only scope configuration
      [ScopeCategory.ORGANIZATION_ONLY]: {
        url: 'https://support.tryfinch.com/articles/3187297613-ukg-pro-add-a-service-user-org-only',
        innerHtmlToScroll: {
          'step-1':
            'Step 1: Create a Service Account with the Necessary Permissions',
          'step-2': 'Step 2: Retrieve API Keys & Web Service URL',
        },
      },
      // Pay and organization scope configuration
      [ScopeCategory.PAY_AND_ORGANIZATION]: {
        url: 'https://support.tryfinch.com/articles/6820516534-ukg-pro-add-a-service-user-org-payroll',
        innerHtmlToScroll: {
          'step-1':
            'Step 1: Create a Service Account with the Necessary Permissions',
          'step-2': 'Step 2: Retrieve API Keys & Web Service URL',
        },
      },
      // Benefits scope configuration
      [ScopeCategory.BENEFITS]: {
        url: 'https://support.tryfinch.com/articles/6820516534-ukg-pro-add-a-service-user-org-payroll',
      },
    },
  },
  [PayrollProviderId.UKG_READY]: {
    [ImplementationKind.API_TOKEN]: {
      innerHtmlToScroll: {
        'step-1': 'Step 1: Retrieve the Web Service URL and Company',
        'step-2': 'Step 2: Create a Security Profile',
        'step-3': 'Step 3: Create a Service Account',
      },
      [ScopeCategory.BASE]: {
        url: 'https://support.tryfinch.com/articles/4863780132-ukg-ready-add-a-service-user',
      },
      [ScopeCategory.ORGANIZATION_ONLY]: {
        url: 'https://support.tryfinch.com/articles/2474293955-ukg-ready-add-a-service-account-org-only',
        innerHtmlToScroll: {
          'step-1': 'Step 1: Retrieve the Web Service URL and Company',
          'step-2': 'Step 2: Create a Security Profile',
          'step-3': 'Step 3: Create a Service Account',
        },
      },
      [ScopeCategory.PAY_AND_ORGANIZATION]: {
        url: 'https://support.tryfinch.com/articles/6643459729-ukg-ready-add-a-service-user-org-payroll',
        innerHtmlToScroll: {
          'step-1': 'Step 1: Retrieve the Web Service URL and Company',
          'step-2': 'Step 2: Create a Security Profile',
          'step-3': 'Step 3: Create a Service Account',
        },
      },
      [ScopeCategory.BENEFITS]: {
        url: 'https://support.tryfinch.com/articles/6643459729-ukg-ready-add-a-service-user-org-payroll',
      },
    },
  },
  [PayrollProviderId.WORKDAY]: {
    [ImplementationKind.API_TOKEN]: {
      innerHtmlToScroll: {
        'step-1': 'Step 1: Retrieve the Workday Tenant ID',
        'step-2': 'Step 2: Create an Integration System User',
        'step-3': 'Step 3: Configure a Security Group',
        'step-4': 'Step 4: Configure the Domain Security Policy Permissions',
        'step-5': 'Step 5: Activate Security Policy Changes',
        'step-6': 'Step 6: Configure Authentication Policy',
        'step-7': 'Step 7: Activate Authentication Policy Changes',
        'step-8': 'Step 8: Retrieve the Web Services Endpoint URL',
      },
      [ScopeCategory.BASE]: {
        url: 'https://support.tryfinch.com/articles/4120312435-workday-add-an-integration-system-user-org-payroll',
      },
      [ScopeCategory.ORGANIZATION_ONLY]: {
        url: 'https://support.tryfinch.com/articles/5284425985-workday-add-an-integration-system-user-org-only',
      },
      [ScopeCategory.PAY_AND_ORGANIZATION]: {
        url: 'https://support.tryfinch.com/articles/4120312435-workday-add-an-integration-system-user-org-payroll',
      },
      [ScopeCategory.BENADMIN]: {
        url: 'https://support.tryfinch.com/articles/4079197940-workday-add-an-integration-system-user-benefits',
      },
    },
  },
};
